import React__default from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../IconButton/fa92464f43077b1cbdd0bb416ee549d83eadaee9906eab0987bbf0ad889eddad.cfe-internal.js';
import '../../icons/index.es.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import IconButton from '../IconButton/399631eebecc03da030561fb1a25c35c2d29c5e4645700b7fca3cf592ca75904.cfe-internal.js';
import CaretDownIcon from '../../icons/components/73d3471aca1dff4440a8cc17ea32e0d74c1288510555f4fa0f8fa22626891c14.cfe-internal.js';
import CaretRightIcon from '../../icons/components/82dcfb9e8213e07dd0f09ea30fb2e69d29919d77b7a35c6ea959a855f4e59745.cfe-internal.js';

/* eslint-disable jsx-a11y/no-static-element-interactions */
var AdvancedTableRowExpandButton = function AdvancedTableRowExpandButton(_ref) {
  var isRowExpanded = _ref.isRowExpanded,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    onFocus = _ref.onFocus,
    dataTestId = _ref['data-testid'];
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var state = isRowExpanded ? 'expanded' : 'collapsed';
  var labels = {
    expanded: translate('advancedTable.collapseRow'),
    collapsed: translate('advancedTable.expandRow')
  };
  return /*#__PURE__*/React__default.createElement("div", {
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    "data-testid": dataTestId,
    "aria-label": labels[state],
    tooltipContent: labels[state],
    tabIndex: -1,
    onFocus: onFocus
  }, state === 'expanded' ? /*#__PURE__*/React__default.createElement(CaretDownIcon, null) : /*#__PURE__*/React__default.createElement(CaretRightIcon, null)));
};

export { AdvancedTableRowExpandButton as default };
